module.exports = "/packs/images/youth-education/hero-mobile@2x-fe4624bcbe3cf6c9b74fb06769fc03f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/youth-education/hero-mobile@2x.jpg
// module id = 1783
// module chunks = 0